import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { User } from '../user.model';
import { UserCustomField } from './additional-settings/additional-setting.model';
import { KeyValuePair } from "../../shared-module/common/models/KeyValuePair.model";
import { UrlPrefix } from "../../shared-module/common/constants/url-prefix.constants";
import { EuAccessUserData } from './general/user-general-lookup.model';

@Injectable()
export class AddEditUserService {


  constructor(private http: HttpClient) {
  }

  public save(user: User): Observable<number> {
    return this.http.post<number>(`${UrlPrefix.OLD_SETUP_API_PREFIX}/users`, JSON.stringify(user));
  }

  public getUser(userId: number): Observable<User> {
    return this.http.get<User>(`${UrlPrefix.OLD_SETUP_API_PREFIX}/users/${userId}`);
  }

  public getUserTypeById(userTypeId: number): Observable<any> {
    return this.http.get<any>(`${UrlPrefix.OLD_SETUP_API_PREFIX}/userTypes/${userTypeId}`);
  }

  public getAllUserTypes(): Observable<any> {
    return this.http.get<any>(`${UrlPrefix.OLD_SETUP_API_PREFIX}/userTypes`);
  }

  public getNames(userIds: Array<number>): Observable<Array<KeyValuePair<number, string>>> {
    return this.http.post<Array<KeyValuePair<number, string>>>(`${UrlPrefix.OLD_SETUP_API_PREFIX}/users/names`, userIds);
  }

  getCustomFields(): Observable<Array<UserCustomField>> {
    return this.http.get<Array<UserCustomField>>(`${UrlPrefix.OLD_SETUP_API_PREFIX}/users/customFields`);
  }
    
  saveEuAccesUserData(euAccessUserData: EuAccessUserData): Observable<EuAccessUserData> {
    return this.http.post<EuAccessUserData>(`${UrlPrefix.OLD_SETUP_API_PREFIX}/euAccess/userData`, euAccessUserData);
  }
}
